import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-number-input2',
  templateUrl: './number-input2.component.html',
  styleUrls: ['./number-input2.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: NumberInput2Component,
    },
  ],
  standalone: false,
})
export class NumberInput2Component implements ControlValueAccessor {
  @Input() editable = true;
  @Input() minimum: number = -Infinity;
  @Input() set maximum(maximum: number) {
    if (typeof maximum === 'number') {
      this._maximum = maximum;

      const oldNumber = this.number;
      this.number = this.clumpToValidRange(this.number);
      if (oldNumber !== this.number) {
        this.onChanged?.(this.number);
      }
    } else {
      this._maximum = Infinity;
    }
  }

  private _maximum: number = Infinity;

  number: number = null;
  disabled = false;

  private onChanged: (num: number) => void;

  increment(): void {
    if (this.disabled || !this.editable) return;

    this.number = this.clumpToValidRange(this.number + 1);
    this.onChanged?.(this.number);
  }

  decrement(): void {
    if (this.disabled || !this.editable) return;

    this.number = this.clumpToValidRange(this.number - 1);
    this.onChanged?.(this.number);
  }

  onInput(evt: InputEvent): void {
    const elm = evt.target as HTMLInputElement;
    if (elm.value === '') return;

    this.number = this.clumpToValidRange(parseInt(elm.value));
    elm.value = String(this.number);
    this.onChanged?.(this.number);
  }

  writeValue(num: number): void {
    this.number = this.clumpToValidRange(num);
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private clumpToValidRange(num: number): number {
    if (isNaN(num)) return this.minimum;

    return Math.max(this.minimum, Math.min(this._maximum, num));
  }
}
